export default __webpack_public_path__ + "static/media/fm.c916f997.svg";